import { Container, Image } from '@mantine/core';
import Logo from '@src/assets/voylogic-logo.png';
import classes from './auth-logo.module.css';

function AuthLogo() {
  return (
    <Container mb={0} mt={0} className={classes.wrapper}>
      <Image src={Logo} alt="VoyLogic" fit="contain" className={classes.logo} />
    </Container>
  );
}

export default AuthLogo;
